import { ReactComponent as ChevronRight } from "assets/images/chevron-right.svg";
import { Box, Icon } from "components";
import PropTypes from "prop-types";
import styled from "styled-components";

const COLORS = {
  current: "#FFFFFF",
  completed: "#212151",
  future: "#9499DE",
  currentText: "#212151",
  futureText: "#574FCC",
};

const Stepper = ({
  numberOfSteps,
  currentStep,
  onNext,
  variant = "default",
}) => {
  return (
    <Box
      position={variant === "default" ? "fixed" : "static"}
      bottom={"0"}
      w="100%"
    >
      <StepperContainer>
        {[...Array(numberOfSteps)].map((_, index) => (
          <StepperItem key={index}>
            {index !== 0 && (
              <ConnectingLine
                isCompleted={index <= currentStep}
                isCurrent={variant === "dots" && index === currentStep + 1}
              />
            )}
            <StepBubble
              isCompleted={
                variant === "dots" ? index < currentStep : index <= currentStep
              }
              isCurrent={variant === "dots" && index === currentStep}
            >
              {index < currentStep ? (
                <Icon name="Check" color="textQuaternary" />
              ) : (
                <StepNumber
                  isCurrent={variant === "dots" && index === currentStep}
                >
                  {index + 1}
                </StepNumber>
              )}
            </StepBubble>
          </StepperItem>
        ))}
      </StepperContainer>
      {variant === "default" && (
        <Box d="flex" justifyContent="center" mB="xl">
          <CircleButtonStyled onClick={onNext}>
            <ChevronRight />
          </CircleButtonStyled>
        </Box>
      )}
    </Box>
  );
};

Stepper.propTypes = {
  numberOfSteps: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  onNext: PropTypes.func,
  variant: PropTypes.oneOf(["default", "dots"]),
};

export const StepperDots = (props) => <Stepper {...props} variant="dots" />;

// ===========================
//    # Styled Components #
// ===========================

const StepperContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StepperItem = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const StepBubble = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ isCurrent, isCompleted }) => {
    if (isCurrent) return COLORS.current;
    if (isCompleted) return COLORS.completed;
    return COLORS.future;
  }};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`;

const ConnectingLine = styled.div`
  width: 65px;
  height: 2px;
  background-color: ${({ isCurrent, isCompleted }) => {
    if (isCurrent) return COLORS.current;
    if (isCompleted) return COLORS.completed;
    return COLORS.future;
  }};
  margin: 0;
`;

const StepNumber = styled.span`
  color: ${({ isCurrent }) =>
    isCurrent ? COLORS.currentText : COLORS.futureText};
  font-size: 14px;
  font-weight: 500;
`;

export const CircleButtonStyled = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #797fd6;
  border: none;
  cursor: pointer;
`;

export default Stepper;
